<template>
  <div v-if="jwtAccessValid()" class="container">
    <header>
      <h2 class="align-middle">Выручка за смену</h2>
    </header>
    <b-row align-v="center" class="mb-2">
      <b-col sm="3">
        <b-form-input type="date" v-model="reportDate"></b-form-input>
        <!-- <datetime-widget :model.sync="reportDate" :date-only="true"></datetime-widget> -->
      </b-col>
      <b-col sm="2">
        <b-button 
        variant="success" 
        @click="fetchReportData()">
          Сформировать
        </b-button>
      </b-col>
    </b-row>

    <b-overlay
    id="overlay-background"
    :show="!reportDataIsActual"
    variant="white"
    opacity="0.50"
    blur="2px"
    class="d-inline-block"
    style="float:left">
    <template v-slot:overlay>
      <div></div>
    </template>
      <b-table striped hover :items="reportData" :fields="reportFields">
        <template slot="bottom-row" slot-scope>
          <td><span class='total'>Итого(смена)</span></td>
          <td><span class='total'>{{ colSum('amountDayShift') }}</span></td>
          <td><span class='total'>{{ colSum('amountNightShift') }}</span></td>
          <td><span class='total'>{{ colSum('amountMonth') }}</span></td>
          <td></td>
          <td></td>
          <td><span class='total'></span></td>
        </template>
      </b-table>
    </b-overlay>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { HTTP } from '@/script/http-common'

export default {
  name: 'ReportRevenue',
  components: {
  },
  
  props: {
  },

  data () {
    return {
      reportData: [],
      reportDate: null,
      reportFields: [
        {
          key: 'shop',
          label: 'Магазин',
          sortable: true,
        },
        {
          key: 'amountDayShift',
          label: 'Выручка за день',
          sortable: true,
        },
        {
          key: 'amountNightShift',
          label: 'Выручка за ночь',
          sortable: true,
        },
        {
          key: 'amountMonth',
          label: 'Выручка за месяц',
          sortable: true,
        },
        {
          key: 'dynamicPrevMonth',
          label: 'Динамика с прошлым месяцем',
          sortable: true,
        },
        {
          key: 'dynamicPrevYear',
          label: 'Динамика  с этим месяцем в прошлом году',
          sortable: true,
        },
        {
          key: 'percentMonthPlan',
          label: 'Выполнено от месячного плана, %',
          sortable: true,
        },
      ],
    }       
  },
  
  computed: {
    ...mapGetters([
      'jwtAccess',
      'jwtAccessValid'
    ]),

    reportDataIsActual() {
      const vm = this
      let status = true
      if (vm.reportData.length > 0) {
        status = (vm.reportData[0].date == vm.reportDate) ? true : false
      }
      return status
    },
  },

  methods: {
    async fetchReportData() {
      const vm = this
      try {
        let response = await HTTP(vm.jwtAccess()).get(`report-revenue/?date=${vm.reportDate}`)
        if (response.status >= 200 && response.status < 300) {
          vm.reportData = response.data
        }
      } catch(error) {
        console.log(error)
      }
    },

    colSum(key) {
      const vm = this
      return vm.reportData.reduce((a, b) => a + (b[key] || 0), 0)
    },
  },

  mounted() {
    const vm = this
    vm.reportDate = (new Date).toISOString().split("T")[0]
    vm.fetchReportData()
  },
  
}
</script>

<style scoped>
header {
  text-align: left;
}

.total {
   font-weight: bold;
}

</style>